import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';

export interface useDeleteWorkshopVerificationRequestMutationArguments {
  verificationId: number;
}

export default function useDeleteWorkshopVerificationRequestMutation(queryKey: QueryKey) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError<{ message: string }>, useDeleteWorkshopVerificationRequestMutationArguments>({
    mutationFn: (verificationId) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/workshop-verification-request/${verificationId}`);
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey });
    },
  });
}
